import type { NodeCustomProps } from '../../../types/craft';
import { FORM_TEXT_FIELD_NODE_NAME } from '../../../utils/constants';
import { InputBase, defaultProps as defaultInputBaseProps } from './InputBase';
import { FormTextFieldPropsDto } from '../../../dto/craft/props/FormTextFieldPropsDto';

export type FormTextFieldProps = FormTextFieldPropsDto;

export const defaultProps: FormTextFieldProps = {
  ...(defaultInputBaseProps as Omit<typeof defaultInputBaseProps, 'tablet' | 'mobile'>),
  inputType: 'text',
};

const FormTextField = (props: Partial<FormTextFieldProps>) => {
  const mergedProps = { ...defaultProps, ...props };
  return <InputBase {...mergedProps} />;
};

FormTextField.craft = {
  displayName: FORM_TEXT_FIELD_NODE_NAME,
  props: defaultProps,
  custom: {
    displayName: 'Text',
    isLocked: false,
  } as NodeCustomProps,
};

export default FormTextField;
